module.exports = __webpack_public_path__ + "img/thrips-palmi.35526485.jpg";